export const urls = {
  getReportsByDate: "/impact-reports/get_report_stats/?range=",
  getReport: "/impact-reports/get-report",
  getReportById: (id) => `/impact-reports/${id}`,
};
